import { OpenAPI } from "simplydo/interfaces";

export const webhooks = (api) => ({
  get(
    type: string,
    typeId: string,
    success: (data: OpenAPI.GET<"/webhooks">["response"]) => void,
    fail: (error: Error) => void,
  ) {
    api.authenticatedRequest(
      "GET",
      `/webhooks?type=${type}&typeId=${typeId}`,
      null,
      success,
      fail,
    );
  },
  create(
    data: OpenAPI.POST<"/webhooks">["requestBody"],
    success: (data: OpenAPI.POST<"/webhooks">["response"]) => void,
    fail: (error: Error) => void,
  ) {
    api.authenticatedRequest("POST", "/webhooks", data, success, fail);
  },
  delete(
    id: string,
    success: (data: OpenAPI.DELETE<"/webhooks/{id}">["response"]) => void,
    fail: (error: Error) => void,
  ) {
    api.authenticatedRequest("DELETE", `/webhooks/${id}`, null, success, fail);
  },
});
